import React, { useState } from 'react';

function StepNine({ formData, onNext }) {
    const [needsAdjustment, setNeedsAdjustment] = useState(formData.needsAdjustment || '');
    const [adjustmentDetails, setAdjustmentDetails] = useState(formData.adjustmentDetails || '');
    const [error, setError] = useState('');

    const handleContinue = () => {
        if (!needsAdjustment) {
            setError('Please select Yes or No.');
            return;
        }

        if (needsAdjustment === 'yes' && !adjustmentDetails.trim()) {
            setError('Please give details about the adjustments you require.');
            return;
        }

        setError('');
        onNext({ needsAdjustment, adjustmentDetails });
    };

    const isFormValid =
        needsAdjustment === 'no' ||
        (needsAdjustment === 'yes' && adjustmentDetails.trim());

    return (
        <div className="step-form">
            <h6 className="mb-4">Adjustments</h6>

            {error && <div className="alert alert-danger">{error}</div>}

            <p>Do you require any adjustments to enable you to carry out your work safely? <span className="text-danger">*</span></p>
            <div className="row">
                <div className="col-lg-6">
                    <div className="form-check mb-2">
                        <input
                            className="form-check-input"
                            type="radio"
                            name="needsAdjustment"
                            id="adjustmentYes"
                            value="yes"
                            checked={needsAdjustment === 'yes'}
                            onChange={() => setNeedsAdjustment('yes')}
                        />
                        <label className="form-check-label" htmlFor="adjustmentYes">
                            Yes
                        </label>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="form-check mb-3">
                        <input
                            className="form-check-input"
                            type="radio"
                            name="needsAdjustment"
                            id="adjustmentNo"
                            value="no"
                            checked={needsAdjustment === 'no'}
                            onChange={() => setNeedsAdjustment('no')}
                        />
                        <label className="form-check-label" htmlFor="adjustmentNo">
                            No
                        </label>
                    </div>
                </div>
            </div>

            {needsAdjustment === 'yes' && (
                <div className="mb-3">
                    <label className="form-label">Please give details:</label>
                    <textarea
                        className="form-control"
                        placeholder="Please give details"
                        rows="4"
                        value={adjustmentDetails}
                        onChange={e => setAdjustmentDetails(e.target.value)}
                    />
                </div>
            )}

            <div className="text-end mt-5">
                <button
                    className="btn btn-dark px-4"
                    onClick={handleContinue}
                    disabled={!isFormValid}
                >
                    Next
                </button>
            </div>
        </div>
    );
}

export default StepNine;
